module.exports = __webpack_public_path__ + "img/rupee-sign.4da5ab8c.svg";